import "../assets/styles/ansa-theme.css";
import "primeflex/primeflex.css";

import React from "react";
import { Navigate } from "react-router-dom";

import Login from "../pages/Authentication/Login";
import OTPVerification from "../pages/Authentication/OTPVerification";
import Register from "../pages/Authentication/Register";

import Homepage from "../pages/Homepage";
import AnsaHelp from '../pages/AnsaHelp';
import PaymentStatus from "../pages/PaymentStatus";
import MakePayment from "../pages/MakePayment";

import MyAccount from "../pages/MyAccount/View";
import EditMyAccount from "../pages/MyAccount/Edit";

import NotFound from "../pages/NotFound";
import MaintenanceMode from "../pages/MaintenanceMode";

import GetQuotes from "../pages/GetQuotes";
import SelectCarPlan from '../pages/GetQuotes/SelectCarPlan';
import CarDetails from '../pages/GetQuotes/CarDetails';
import SelectCarVariant from '../pages/GetQuotes/SelectCarVariant';
import InsuranceAddOns from '../pages/GetQuotes/AddOns';
import AddOnOthers from '../pages/GetQuotes/AddOnOthers';
import AddOnSumInsured from '../pages/GetQuotes/AddOnSumInsured';
import AddOnM02 from '../pages/GetQuotes/AddOnM02';
import AddOnDrivers from '../pages/GetQuotes/AddOnDrivers';
import AddOnMPA from '../pages/GetQuotes/AddOnMPA';
import AddOnM51 from '../pages/GetQuotes/AddOnM51';
import AddOnP07A from '../pages/GetQuotes/AddOnP07A';
import AddOnP10A from '../pages/GetQuotes/AddOnP10A';
import AddOn112 from '../pages/GetQuotes/AddOn112';
import AddOnD027 from '../pages/GetQuotes/AddOnD027';
import AddOnD01A from '../pages/GetQuotes/AddOnD01A';
import AddOnPABERW from '../pages/GetQuotes/AddOnPABERW';
import AddOnPAB3 from '../pages/GetQuotes/AddOnPAB3';
import GetHealthQuotes from '../pages/GetHealthQuotes';
import MoreAboutHealth from '../pages/GetHealthQuotes/MoreAboutHealth';
import SelectHealthPlan from '../pages/GetHealthQuotes/SelectHealthPlan';
import HealthQuestionnaire from '../pages/GetHealthQuotes/Questionnaires';
import IDVerification from '../pages/GetHealthQuotes/IDVerification';
import PassportVerification from '../pages/GetHealthQuotes/UploadPassport';
import DeclarationOne from '../pages/GetHealthQuotes/DeclarationOne';
import Nomination from '../pages/GetHealthQuotes/Nomination';
import DeclarationTwo from '../pages/GetHealthQuotes/DeclarationTwo';

import SubmitForPassport from "../pages/GetHealthQuotes/SubmitForPassport";
import SubmitForPassportFailed from "../pages/GetHealthQuotes/SubmitForPassportFailed";
import HealthPaymentPage from "../pages/GetHealthQuotes/HealthPayments";
import ClientInfo from "../pages/GetQuotes/ClientInfo";
import MotorPaymentPage from "../pages/GetQuotes/MotorPaymentPage";
import LoadingQuotations from "../pages/GetQuotes/LoadingQuotations";
import AddOnPA from "../pages/GetQuotes/AddOnPA";
import AddOnA001 from "../pages/GetQuotes/AddOnA001";
import AddOnGeneraliDriver from "../pages/GetQuotes/AddOnGeneraliDrivers";
import AddOnAllianzDriver from "../pages/GetQuotes/AddOnAllianzDrivers";
import ReminderPage from "../pages/ReminderPage";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Homepage /> },
  { path: "/ansa-help", component: <AnsaHelp /> },
	{ path: "/payment/response", component: <PaymentStatus /> },
	{ path: "/payment/makepayment", component: <MakePayment /> },
	{ path: "/reminder-summary", component: <ReminderPage /> },

  // Get motor quotes
  { path: "/get-quotes", component: <GetQuotes /> },
  { path: "/get-quote/select-car-plan", component: <SelectCarPlan /> },
  { path: "/get-quote/car-details", component: <CarDetails /> },
	{ path: "/get-quote/select-car-variant", component: <SelectCarVariant /> },
  { path: "/get-quote/loading-quotations", component: <LoadingQuotations /> },
  { path: "/get-quote/add-ons", component: <InsuranceAddOns /> },
	{ path: "/get-quote/add-on-sum-insured", component: <AddOnSumInsured /> },
	{ path: "/get-quote/add-on-m02", component: <AddOnM02 /> },
	{ path: "/get-quote/add-on-drivers", component: <AddOnDrivers /> },
	{ path: "/get-quote/add-driver", component: <AddOnGeneraliDriver /> },
	{ path: "/get-quote/allianz-add-driver", component: <AddOnAllianzDriver /> },
	{ path: "/get-quote/add-on-mpa", component: <AddOnMPA /> },
  { path: "/get-quote/add-on-etiqa-lou", component: <AddOnP10A /> },
  { path: "/get-quote/add-on-etiqa-cart", component: <AddOnP07A /> },
  { path: "/get-quote/add-on-lonpac-cart", component: <AddOnM51 /> },
	{ path: "/get-quote/add-on-sompo-cart", component: <AddOn112 /> },
	{ path: "/get-quote/add-on-d027", component: <AddOnD027 /> },
	{ path: "/get-quote/add-on-d01a", component: <AddOnD01A /> },
	{ path: "/get-quote/add-on-pa", component: <AddOnPA /> },
	{ path: "/get-quote/add-on-a001", component: <AddOnA001 /> },
  { path: "/get-quote/add-on-paberw", component: <AddOnPABERW /> },
  { path: "/get-quote/add-on-pab3", component: <AddOnPAB3 /> },
	{ path: "/get-quote/add-on-others", component: <AddOnOthers /> },
	{ path: "/get-quote/client-info", component: <ClientInfo /> },
	{ path: "/get-quote/payment-page", component: <MotorPaymentPage /> },

  //Get health quotes
  { path: "/get-health-quotes", component: <GetHealthQuotes /> },
  { path: "/get-health-quotes/negative-submission", component: <SubmitForPassport /> },
  { path: "/get-health-quotes/negative-submission-failed", component: <SubmitForPassportFailed /> },
  { path: "/get-health-quotes/more-about-ansa", component: <MoreAboutHealth /> },
  { path: "/get-health-quotes/select-health-plan", component: <SelectHealthPlan /> },
  { path: "/get-health-quotes/questionnaires", component: <HealthQuestionnaire /> },
  { path: "/get-health-quotes/verify-id", component: <IDVerification /> },
  { path: "/get-health-quotes/verify-passport", component: <PassportVerification /> },
  { path: "/get-health-quotes/declaration-one", component: <DeclarationOne /> },
  { path: "/get-health-quotes/nomination", component: <Nomination /> },
  { path: "/get-health-quotes/declaration-two", component: <DeclarationTwo /> },
  { path: "/get-health-quotes/health-payments", component: <HealthPaymentPage /> },

	{ path: "/my-account", component: <MyAccount /> },
	{ path: "/my-account/edit", component: <EditMyAccount /> },
	{ path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
	{ path: "/login", component: <Login /> },
	{ path: "/otp-verification", component: <OTPVerification /> },
	{ path: "/register", component: <Register /> },

	{ path: "/not-found", component: <NotFound /> },
	{ path: "/maintenance-mode", component: <MaintenanceMode /> },
];

export { authProtectedRoutes, publicRoutes };